import { QuotationTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1481. 見積タスクコメント欄に見積内容を記載して申請更新
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/update_billing_schedule_checked
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
  billing_schedule_checked: boolean;
};

const updateBillingScheduleChecked = (props: Props): Promise<QuotationTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.id}/update_billing_schedule_checked`,
    props
  );
};

export const useUpdateBillingScheduleChecked = () => {
  return useMutation({
    mutationFn: updateBillingScheduleChecked,
  });
};
